import { X } from 'lucide-react';
import { type ReactNode } from 'react';

import { Button } from '@/ui/primitives/button';

export interface FiltroAtivo {
  id: string;
  rotulo: string;
  remover: () => void;
}

interface BarraFiltrosProps {
  /** Controles (busca, selects, período). */
  children: ReactNode;
  ativos: readonly FiltroAtivo[];
  limparTudo?: () => void;
}

/** Controles de filtro + chips do que está aplicado (cada chip remove o seu filtro). */
export function BarraFiltros({ children, ativos, limparTudo }: BarraFiltrosProps) {
  return (
    <div className="grid gap-2.5">
      <div className="flex flex-wrap items-center gap-2">{children}</div>
      {ativos.length > 0 && (
        <ul className="flex flex-wrap items-center gap-1.5" aria-label="Filtros aplicados">
          {ativos.map((filtro) => (
            <li
              key={filtro.id}
              className="inline-flex animate-surgir items-center gap-1 rounded-pilula border border-marca/25 bg-marca-suave py-0.5 pl-2.5 pr-1 text-xs text-marca"
            >
              {filtro.rotulo}
              <button
                type="button"
                onClick={filtro.remover}
                aria-label={`Remover filtro ${filtro.rotulo}`}
                className="grid size-4 place-items-center rounded-pilula hover:bg-marca/15"
              >
                <X className="size-3" aria-hidden />
              </button>
            </li>
          ))}
          {limparTudo && ativos.length > 1 && (
            <li>
              <Button variante="link" tamanho="sm" onClick={limparTudo}>
                Limpar filtros
              </Button>
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
